// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e09ead92","239":"bd2b8117","455":"afa6c0e8","977":"6cd135f8"}[chunkId] + ".chunk.js";
};